<template>
  <div class="m-page m-p3">
    <h2>Deductions</h2>
    <p>Enter the amount for each deduction that applies to you.</p>
    <div class="m-p3__deductions">
      <div class="m-p3__col">
        <div class="m-p3__input-group">
          <label for="charitableContributions">Charitable Contributions:</label>
          <div class="m-p3__input-container">
            <vue-numeric id="charitableContributions" class="m-p3__input" v-model="charitableContributions" currency="$" separator="," :precision="2" :max="999999999" placeholder="$0.00" @focus.native="$event.target.select()" @click.native="$event.target.setSelectionRange(0,9999)" @input="updateStore('charitableContributions', charitableContributions)"></vue-numeric>
            <div class="m-radiocard__popover">
              <el-popover
                slot="popover"
                placement="top"
                width="194"
                trigger="click">
                <slot>The percentage limit for charitable cash donations by an individual taxpayer to public charities and certain other organizations has increased from 50% to 60% of income.</slot>
                <el-button class="override-helpbtn" slot="reference" circle>
                  <svg class="override-helpbtn-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 5.8 8.8">
                    <path fill="#FFF" d="M5.8,2.4C5.8,0.7,4.4,0,3,0C1.5-0.1,0.1,1,0,2.6c0,0,0,0,0,0l1.9,0.2c0-0.6,0.4-1.1,1-1.1	c0,0,0,0,0,0c0.4,0,0.8,0.3,0.9,0.7c0,0,0,0.1,0,0.1c0,0.3-0.2,0.7-0.5,0.9L2.9,3.8C2.3,4.2,2,4.8,2,5.6V6h1.9V5.7	C3.9,5.2,4,5,4.5,4.6C5.3,4.2,5.8,3.3,5.8,2.4z M4.1,7.7c0-0.6-0.5-1.1-1.2-1.1C2.3,6.5,1.8,7,1.7,7.7c0,0.6,0.5,1.2,1.1,1.2	c0,0,0.1,0,0.1,0C3.6,8.9,4.1,8.4,4.1,7.7C4.1,7.7,4.1,7.7,4.1,7.7L4.1,7.7z"/>
                  </svg>
                </el-button>
              </el-popover>
            </div>
          </div>
        </div>

        <div class="m-p3__input-group">
          <label for="medicalAndDental">Medical & Dental Expenses:</label>
          <vue-numeric id="medicalAndDental" class="m-p3__input" v-model="medicalAndDental" currency="$" separator="," :precision="2" :max="999999999" placeholder="$0.00" @focus.native="$event.target.select()" @click.native="$event.target.setSelectionRange(0,9999)" @input="updateStore('medicalAndDental', medicalAndDental)"></vue-numeric>
        </div>
      </div>

      <div class="m-p3__col">
        <div class="m-p3__input-group">
          <label for="mortgageInterest">Mortgage Interest:</label>
          <div class="m-p3__input-container">
            <vue-numeric id="mortgageInterest" class="m-p3__input" v-model="mortgageInterest" currency="$" separator="," :precision="2" :max="999999999" placeholder="$0.00" @focus.native="$event.target.select()" @click.native="$event.target.setSelectionRange(0,9999)" @input="updateStore('mortgageInterest', mortgageInterest)"></vue-numeric>
            <div class="m-radiocard__popover">
              <el-popover
                slot="popover"
                placement="top"
                width="194"
                trigger="click">
                <slot>Mortgage interest can be deducted based on a loan of $750,000 down from $1,000,000 if the loan was taken out after 12/15/17</slot>
                <el-button class="override-helpbtn" slot="reference" circle>
                  <svg class="override-helpbtn-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 5.8 8.8">
                    <path fill="#FFF" d="M5.8,2.4C5.8,0.7,4.4,0,3,0C1.5-0.1,0.1,1,0,2.6c0,0,0,0,0,0l1.9,0.2c0-0.6,0.4-1.1,1-1.1	c0,0,0,0,0,0c0.4,0,0.8,0.3,0.9,0.7c0,0,0,0.1,0,0.1c0,0.3-0.2,0.7-0.5,0.9L2.9,3.8C2.3,4.2,2,4.8,2,5.6V6h1.9V5.7	C3.9,5.2,4,5,4.5,4.6C5.3,4.2,5.8,3.3,5.8,2.4z M4.1,7.7c0-0.6-0.5-1.1-1.2-1.1C2.3,6.5,1.8,7,1.7,7.7c0,0.6,0.5,1.2,1.1,1.2	c0,0,0.1,0,0.1,0C3.6,8.9,4.1,8.4,4.1,7.7C4.1,7.7,4.1,7.7,4.1,7.7L4.1,7.7z"/>
                  </svg>
                </el-button>
              </el-popover>
            </div>
          </div>
        </div>

        <div class="m-p3__input-group">
          <label for="variousTaxes">Property Tax, State Income Tax Withholding, Sales and Local Income Tax</label>
          <div class="m-p3__input-container">
            <vue-numeric id="variousTaxes" class="m-p3__input" v-model="variousTaxes" currency="$" separator="," :precision="2" :max="999999999" placeholder="$0.00" @focus.native="$event.target.select()" @click.native="$event.target.setSelectionRange(0,9999)" @input="updateStore('variousTaxes', variousTaxes)"></vue-numeric>
            <div class="m-radiocard__popover">
              <el-popover
                slot="popover"
                placement="top"
                width="194"
                trigger="click">
                <slot>The total of property taxes, state income tax withholdings, and sales taxes cannot exceed $10,000</slot>
                <el-button class="override-helpbtn" slot="reference" circle>
                  <svg class="override-helpbtn-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 5.8 8.8">
                    <path fill="#FFF" d="M5.8,2.4C5.8,0.7,4.4,0,3,0C1.5-0.1,0.1,1,0,2.6c0,0,0,0,0,0l1.9,0.2c0-0.6,0.4-1.1,1-1.1	c0,0,0,0,0,0c0.4,0,0.8,0.3,0.9,0.7c0,0,0,0.1,0,0.1c0,0.3-0.2,0.7-0.5,0.9L2.9,3.8C2.3,4.2,2,4.8,2,5.6V6h1.9V5.7	C3.9,5.2,4,5,4.5,4.6C5.3,4.2,5.8,3.3,5.8,2.4z M4.1,7.7c0-0.6-0.5-1.1-1.2-1.1C2.3,6.5,1.8,7,1.7,7.7c0,0.6,0.5,1.2,1.1,1.2	c0,0,0.1,0,0.1,0C3.6,8.9,4.1,8.4,4.1,7.7C4.1,7.7,4.1,7.7,4.1,7.7L4.1,7.7z"/>
                  </svg>
                </el-button>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueNumeric from 'vue-numeric'
import { updateStore } from './mixins/updateStore'

export default {
  mounted () {
    this.charitableContributions = this.$store.state.charitableContributions,
    this.medicalAndDental = this.$store.state.medicalAndDental,
    this.mortgageInterest = this.$store.state.mortgageInterest,
    this.personalPropertyTax = this.$store.state.personalPropertyTax,
    this.variousTaxes = this.$store.state.variousTaxes
  },
  name: 'Page3',
  components: {
    VueNumeric
  },
  mixins: [updateStore],
  data () {
    return {
      charitableContributions: 0,
      medicalAndDental: 0,
      mortgageInterest: 0,
      personalPropertyTax: 0,
      variousTaxes: 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../scss/vars';
.m-p3 {
  &__deductions {
    width: 100%;
    display: flex;
    flex-flow: row;
    @media (max-width: $sm) {
      flex-flow: column;
    }
  }
  &__col {
    width: 50%;
    display: flex;
    flex-flow: column;
    align-items: center;
    @media (max-width: $sm) {
      width: 100%;
    }
  }
  &__input-group {
    width: 100%;
    max-width: 198px;
    display: flex;
    flex-flow: column;
    margin-bottom: 22px;
    label {
      margin-bottom: 6px;
      font-family: $fPrimary;
      font-weight: $fMed;
      font-size: 12px;
      line-height: 20px;
    }
  }
  &__input-container {
    width: 100%;
    position: relative;
  }
  &__input {
    height: 40px;
    width: 100%;
    max-width: 198px;
    display: block;
    font-family: $fPrimary;
    font-size: 14px;
    font-weight: $fReg;
    line-height: 20px;
    padding-left: 18px;
    padding-right: 18px;
    border-radius: 4px;
    border: 1px solid $cGray;
    &::placeholder {
      color: $cGray;
    }
  }
}
</style>
